import React from 'react';
import { useAppSelector, useAppDispatch } from '../app/hooks';
import { set_事件_state } from '../slices/baseballApp';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';

const HaveSwingState = () => {

    const dispatch = useAppDispatch();
    const records = useAppSelector(state => state.baseballAppReducer.records);

    const haveSwingState_event = records.事件;
    const haveSwingState = records.結果;
    const style = { margin: -3 };

    return (
        <FormControl component="fieldset">
            <RadioGroup value={haveSwingState_event} onClick={(event) => { dispatch(set_事件_state(event.target.value)) }} row aria-label="radios" name="radios">
                <FormControlLabel style={style} value="界內" control={<Radio size="small" color="primary" />} label="界內" />
                <FormControlLabel style={style} value="界外" control={<Radio size="small" color="primary" />} label="界外" />
                <FormControlLabel style={style} value="揮空" control={<Radio size="small" color="primary" />} label="揮空" />
            </RadioGroup>
        </FormControl>
    );
}

export default HaveSwingState;
